import { render, staticRenderFns } from "./DashboardUpdateSpModal.vue?vue&type=template&id=073794b5&scoped=true&"
import script from "./DashboardUpdateSpModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardUpdateSpModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardUpdateSpModal.vue?vue&type=style&index=0&id=073794b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073794b5",
  null
  
)

export default component.exports